module.exports = __webpack_public_path__ + "img/00001.d3d7b0d1.webp";